import { render, staticRenderFns } from "./administrationPageConfiguration.vue?vue&type=template&id=6abeefaa&scoped=true&"
import script from "./administrationPageConfiguration.vue?vue&type=script&lang=js&"
export * from "./administrationPageConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./administrationPageConfiguration.vue?vue&type=style&index=0&id=6abeefaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abeefaa",
  null
  
)

export default component.exports